module.exports = __webpack_public_path__ + "static/media/loading.596d07b7.svg";